/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdReprocessGrades202,
  PostApiV1ClassroomdisciplineIdReprocessGrades401,
  PostApiV1ClassroomdisciplineIdReprocessGrades404,
  PostApiV1ClassroomdisciplineIdReprocessGradesMutationResponse,
  PostApiV1ClassroomdisciplineIdReprocessGradesPathParams,
} from "../../types/classPlanningController/PostApiV1ClassroomdisciplineIdReprocessGrades.ts";

export const postApiV1ClassroomdisciplineIdReprocessGradesPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessGradesPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdReprocessGrades202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessGrades202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdReprocessGrades401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessGrades401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdReprocessGrades404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessGrades404>;

export const postApiV1ClassroomdisciplineIdReprocessGradesMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdReprocessGrades202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessGradesMutationResponse>;
